import { render, staticRenderFns } from "./travelIndex.vue?vue&type=template&id=0f699dae&scoped=true"
import script from "./travelIndex.vue?vue&type=script&lang=js"
export * from "./travelIndex.vue?vue&type=script&lang=js"
import style0 from "./travelIndex.vue?vue&type=style&index=0&id=0f699dae&prod&lang=css"
import style1 from "./travelIndex.vue?vue&type=style&index=1&id=0f699dae&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f699dae",
  null
  
)

export default component.exports